import { useInfiniteQuery } from '@tanstack/react-query'

import { getReports, GetReportsRequest } from '../services/reportServices'

export const useReports = (
  filters: Omit<GetReportsRequest, 'page'>,
  queryKey: string,
) => {
  return useInfiniteQuery({
    queryKey: [queryKey, filters],
    initialPageParam: 1,
    queryFn: ({ pageParam }) => getReports({
      ...filters,
      page: pageParam,
    }),
    getNextPageParam: (lastPage, allPages) => {
      if (lastPage.reports.length === 0) return undefined // Sem mais páginas
      return allPages.length + 1 // Próxima página
    },
    staleTime: 0,
  })
}
